var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn-banner",style:(_vm.backgroundPromo),on:{"click":function($event){return _vm.promo.callback()}}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.$t(_vm.promo.phrase))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }